<template>
  <div>
    <main class="container-fluid">
      <section class="row">
        <div class="col-4 px-3 py-3"></div>
        <div
          class="col-24 col-md-11 px-md-3 py-md-3 pt-3 pt-md-0 px-3 px-md-0 mb-md-5"
        >
          <div class="col d-column">
            <h1 class="title pt-2 mb-0">VPNs</h1>
            <h1 class="title">
              <span class="pb-2">{{ $ml.get("manageVPNforUsers") }}</span>
            </h1>

            <div>
              <b-nav tabs>
                <b-nav-item
                  :active="menuItem === 'user'"
                  @click="loadData(), (menuItem = 'user')"
                  class="mb-0 pb-0"
                >
                  {{ $ml.get("users") }}
                </b-nav-item>
                <b-nav-item
                  :active="menuItem === 'data'"
                  @click="
                    (programSelectedGeneral = []),
                      loadDataAccessLog(),
                      (menuItem = 'data'),
                      loadGraphAccessLog()
                  "
                  class="mb-0 pb-0"
                >
                  {{ $ml.get("access") }}
                </b-nav-item>
              </b-nav>
            </div>

            <div v-if="menuItem === 'user'" class="col d-column card">
              <div class="card-search">
                <div
                  v-if="listProgram.length"
                  class="row py-2 d-flex justify-content-start"
                >
                  <div class="col-24 mb-2 input-group">
                    <multiselect
                      v-model="programSelected"
                      :options="listProgram"
                      label="name"
                      :searchable="false"
                      :close-on-select="true"
                      :show-labels="false"
                      :allow-empty="false"
                      :preselect-first="true"
                      :multiple="false"
                    >
                    </multiselect>
                  </div>

                  <div class="col-12 pr-2 input-group">
                    <multiselect
                      v-model="vpnState"
                      :options="listState"
                      :searchable="false"
                      :close-on-select="true"
                      :show-labels="false"
                      :preselect-first="false"
                      placeholder="Status"
                      :multiple="false"
                    >
                    </multiselect>
                  </div>

                  <div class="col-12 input-group">
                    <input
                      class="form-control filterInput"
                      v-model="username"
                      :placeholder="$ml.get('user')"
                      aria-label="Search"
                      style="border-right: none"
                    />
                    <div class="input-group-append">
                      <div
                        class="input-group-text"
                        style="background-color: #fff"
                      >
                        <svg width="20" height="20">
                          <image
                            xlink:href="../../../../src/assets/icons/search_s.svg"
                            width="18"
                            height="18"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <table>
                <thead>
                  <tr>
                    <th class="col-9" v-text="$ml.get('specialist')"></th>
                    <th class="col-6">IP</th>
                    <th class="col-5 d-none d-lg-flex">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-show="!listVpnUsers.length" class="loading">
                    <div v-if="loadingListVpn" class="c-loader m-3"></div>
                    <h6 v-else class="col d-flex justify-content-center p-3" v-text="$ml.get('vpnMessage')">
                      Não há uma vpn habilitada neste programa.
                    </h6>
                  </tr>
                  <tr
                    v-show="listVpnUsers.length"
                    v-for="(item, index) in listVpnUsers"
                    :key="index"
                  >
                    <td
                      class="col-9 d-flex align-items-center pointer"
                      @click="modalDetail(item)"
                    >
                      <div
                        class="position-relative d-flex align-items-center align-self-center"
                      >
                        <object
                          width="42"
                          height="42"
                          class="rounded-circle img-m"
                          :data="item.avatar"
                          type="image/png"
                        >
                          <img
                            width="42"
                            height="42"
                            class="rounded-circle img-m"
                            src="../../../assets/images/default.png"
                            alt="Avatar"
                          />
                        </object>
                        <div v-show="item.verified" class="verify">
                          <img
                            src="../../../../src/assets/icons/badge-check.png"
                            width="16"
                            height="16"
                          />
                        </div>

                        <div class="align-self-center pl-3 pointer">
                          <h6 v-text="item.username"></h6>
                        </div>
                      </div>
                    </td>
                    <td
                      class="col-6 d-flex align-items-center mt-1 pointer"
                      @click="modalDetail(item)"
                    >
                      <h6 v-text="item.vpn_ip"></h6>
                    </td>
                    <td class="col-5 d-flex align-items-center">
                      <div class="pl-0 pointer mx-1">
                        <VueCustomTooltip
                          :label="!item.vpn_status ? 'Offline' : 'Online'"
                        >
                          <span
                            :class="item.vpn_status ? 'dot online' : 'dot'"
                          ></span>
                        </VueCustomTooltip>
                      </div>
                    </td>
                    <td class="col-5 d-flex align-items-center">
                      <div
                        class="pl-0 pointer mx-1"
                        style="width: 90px"
                        @click="
                          toogleVpnStatus(
                            item.userId,
                            item.vpn_user_disabled ? 'unblock' : 'block',
                          )
                        "
                      >
                        <VueCustomTooltip
                          v-if="!item.vpn_user_disabled"
                          :label="$ml.get('disable') + ' VPN'"
                        >
                          <a
                            class="badge badge-secondary text-white mb-1 p-1"
                            v-text="$ml.get('disable') + ' VPN'"
                          >
                          </a>
                        </VueCustomTooltip>
                        <VueCustomTooltip
                          v-else
                          :label="$ml.get('activate') + ' VPN'"
                        >
                          <a
                            class="badge badge-secondary text-white mb-1 p-1"
                            v-text="$ml.get('activate') + ' VPN'"
                          >
                          </a>
                        </VueCustomTooltip>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div
                v-show="totalistVpnPages > 10 && !loadingListVpn"
                class="p-3"
              >
                <b-pagination
                  v-model="vpnAtualPage"
                  :total-rows="totalistVpnPages"
                  :per-page="10"
                  :prev-text="$ml.get('previous')"
                  :next-text="$ml.get('next')"
                  align="center"
                >
                </b-pagination>
              </div>
            </div>

            <div v-if="menuItem === 'data'" class="col d-column card">
              <div class="card-search">
                <div
                  v-if="listProgram.length"
                  class="row py-2 d-flex justify-content-start"
                >
                  <div class="col-8 pr-2 input-group">
                    <multiselect
                      v-model="programSelectedGeneral"
                      :options="listProgram"
                      label="name"
                      :searchable="false"
                      :close-on-select="true"
                      :show-labels="false"
                      :allow-empty="true"
                      :preselect-first="false"
                      :multiple="false"
                      :placeholder="$ml.get('allThePrograms')"
                    >
                    </multiselect>
                  </div>

                  <div class="col-6 pr-2 input-group">
                    <b-form-datepicker
                      class="datepicker m-0 p-0"
                      label-help=""
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                      :locale="$ml.get('ln')"
                      today-button
                      reset-button
                      close-button
                      :max="dateSelectedEnd"
                      :label-today-button="$ml.get('today')"
                      :label-reset-button="$ml.get('reset')"
                      :label-close-button="$ml.get('exit')"
                      v-model="dateSelectedStart"
                      :placeholder="$ml.get('start')"
                    >
                    </b-form-datepicker>
                  </div>

                  <div class="col-6 input-group">
                    <b-form-datepicker
                      class="datepicker m-0 p-0"
                      label-help=""
                      :date-format-options="{
                        year: 'numeric',
                        month: 'numeric',
                        day: 'numeric',
                      }"
                      :locale="$ml.get('ln')"
                      today-button
                      reset-button
                      close-button
                      :min="dateSelectedStart"
                      :label-today-button="$ml.get('today')"
                      :label-reset-button="$ml.get('reset')"
                      :label-close-button="$ml.get('exit')"
                      v-model="dateSelectedEnd"
                      :placeholder="$ml.get('end')"
                    >
                    </b-form-datepicker>
                  </div>
                </div>
              </div>
              <table>
                <thead>
                  <tr>
                    <th class="col-7" v-text="$ml.get('specialist')"></th>
                    <th class="col-6">{{ $ml.get("message") }}</th>
                    <th class="col-6">{{ $ml.get("date") }}</th>
                    <th class="col-5 d-none d-lg-flex">IP</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-show="!listVpn.length" class="loading">
                    <div
                      v-if="loadingListVpn === true"
                      class="c-loader m-3"
                    ></div>
                    <h6 v-else class="col d-flex justify-content-center p-3" v-text="$ml.get('vpnMessage')">
                      Não há uma vpn habilitada neste programa.
                    </h6>
                  </tr>
                  <tr
                    v-show="listVpn.length"
                    v-for="(item, index) in listVpn"
                    :key="index"
                  >
                    <td
                      class="col-7 d-flex align-items-center pointer"
                      @click="modalDetail(item)"
                    >
                      <div
                        class="position-relative d-flex align-items-center align-self-center"
                      >
                        <object
                          width="42"
                          height="42"
                          class="rounded-circle img-m"
                          :data="item.avatar"
                          type="image/png"
                        >
                          <img
                            width="42"
                            height="42"
                            class="rounded-circle img-m"
                            src="../../../assets/images/default.png"
                            alt="Avatar"
                          />
                        </object>
                        <div v-show="item.verified" class="verify">
                          <img
                            src="../../../../src/assets/icons/badge-check.png"
                            width="16"
                            height="16"
                          />
                        </div>

                        <div class="align-self-center pl-3 pointer">
                          <h6 v-text="item.username"></h6>
                        </div>
                      </div>
                    </td>
                    <td
                      class="col-6 d-flex align-items-center mt-1 pointer"
                      @click="modalDetail(item)"
                    >
                      <h6 v-text="convertMessage(item.message)"></h6>
                    </td>
                    <td class="col-6 d-flex align-items-center">
                      <div class="pl-0 pointer mx-1">
                        <h6>
                          {{
                            $utils.formatDataLong(
                              new Date(item.timestamp * 1000),
                            )
                          }}
                        </h6>
                      </div>
                    </td>
                    <td class="col-5 d-flex align-items-center">
                      <h6>{{ item.ip }}</h6>
                    </td>
                  </tr>
                </tbody>
              </table>
              <div
                v-show="totalistVpnLogsPages > 10 && !loadingListVpn"
                class="p-3"
              >
                <b-pagination
                  v-model="vpnAtualPage"
                  :total-rows="totalistVpnLogsPages"
                  :per-page="10"
                  :prev-text="$ml.get('previous')"
                  :next-text="$ml.get('next')"
                  align="center"
                >
                </b-pagination>
              </div>
            </div>
          </div>
        </div>

        <div class="col-24 col-md-5 pr-md-3 py-md-3 px-3 px-md-0">
          <div class="card mb-3">
            <div class="card-header border-0 pb-0">
              <div class="d-flex flex-row">
                <span> {{ $ml.get("whatIsaVPNAndHow") }} </span>
              </div>
              <img
                class="img-support"
                src="../../../assets/images/shield.png"
              />
            </div>
            <div class="card-body footer-helper pb-2 d-flex flex-column">
              <p>Virtual Private Network.</p>
              <p>
                {{ $ml.get("thisServiceCreatesAVPNResponsible") }}
              </p>
            </div>
          </div>
          <div
            class="card mb-3"
            v-if="
              menuItem == 'data' &&
              chartOptions2.visible &&
              chartOptions2?.series[0].data.length > 0
            "
          >
            <div class="card-body footer-helper pb-2 d-flex flex-column">
              <div
                v-if="loadingChartUser"
                class="d-flex w-100 align-items-center justify-content-center mb-5"
              >
                <div class="c-loader m-3"></div>
              </div>

              <div v-else id="chartUsers">
                <apexchart
                  type="bar"
                  :height="chartOptions2?.heightChart * 45 + 150"
                  :options="chartOptions2"
                  :series="chartOptions2?.series"
                ></apexchart>
              </div>

              <div class="m-2 mt-4 pt-4">
                <h6 class="title-conexao-usuario">
                  <b>{{ $ml.get("vpnIP") }}:</b> {{ ipVPn?.company_vpn_ip }}
                </h6>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
    <!-- Modal Logs -->
    <b-modal
      id="modal-vpnDetail"
      class="my-modal-log"
      data-bs-keyboard="false"
      hide-header
      hide-footer
      size="xl"
      footer-bg-variant="light"
      @hidden="(initialDate = 's'), (finalDate = '')"
    >
      <template>
        <button
          type="button"
          aria-label="Close"
          class="close pb-0 mb-0"
          @click="$bvModal.hide('modal-vpnDetail')"
        >
          ×
        </button>
      </template>

      <b-container fluid="lg">
        <div class="row w-100">
          <div
            class="col-24 pb-5 px-5 pt-3 d-flex align-items-center justify-content-center"
          >
            <div class="col-10">
              <div class="row align-items-center align-self-center">
                <div class="col-11 row">
                  <object
                    width="42"
                    height="42"
                    class="rounded-circle img-m"
                    :data="hackerSelected.avatar"
                    type="image/png"
                  >
                    <img
                      width="42"
                      height="42"
                      class="rounded-circle img-m"
                      src="../../../assets/images/default.png"
                      alt="Avatar"
                    />
                  </object>

                  <div v-show="hackerSelected.verified" class="verify">
                    <img
                      src="../../../../src/assets/icons/badge-check.png"
                      width="16"
                      height="16"
                    />
                  </div>

                  <div class="pl-3 pointer mt-2">
                    <h5 v-text="hackerSelected.username"></h5>
                  </div>
                </div>

                <div class="form-group float-right m-3">
                  <button
                    @click="exporCSVDetail(hackerSelected)"
                    :disabled="loadingBtnExport"
                    class="btn btn-export"
                  >
                    <Spinner v-show="loadingBtnExport" class="px-5" />
                    <font v-show="!loadingBtnExport" class="mr-1"
                      >{{ $ml.get("exportLogs") }}
                    </font>
                    <img
                      v-show="!loadingBtnExport"
                      class="mb-1"
                      src="../../../assets/icons/download-white.svg"
                      width="15"
                      height="15"
                    />
                  </button>
                </div>
              </div>
            </div>

            <div class="col-14">
              <div class="input-group">
                <b-form-datepicker
                  class="datepicker m-0 p-0 mr-2 mx-2"
                  id=""
                  label-help=""
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                  :locale="$ml.get('ln')"
                  today-button
                  reset-button
                  close-button
                  :max="finalDate"
                  :label-today-button="$ml.get('today')"
                  :label-reset-button="$ml.get('reset')"
                  :label-close-button="$ml.get('exit')"
                  v-model="initialDate"
                  :placeholder="$ml.get('start')"
                >
                </b-form-datepicker>

                <b-form-datepicker
                  class="datepicker m-0 p-0 mr-2 mx-2"
                  id=""
                  label-help=""
                  :date-format-options="{
                    year: 'numeric',
                    month: 'numeric',
                    day: 'numeric',
                  }"
                  :locale="$ml.get('ln')"
                  today-button
                  reset-button
                  close-button
                  :min="initialDate"
                  :label-today-button="$ml.get('today')"
                  :label-reset-button="$ml.get('reset')"
                  :label-close-button="$ml.get('exit')"
                  v-model="finalDate"
                  :placeholder="$ml.get('end')"
                >
                </b-form-datepicker>
              </div>
            </div>
          </div>

          <div
            v-if="loadingDetailVpn"
            class="d-flex w-100 align-items-center justify-content-center mb-5"
          >
            <div class="c-loader m-3"></div>
          </div>

          <div v-else class="col">
            <h6
              v-if="!hackerSelectedDetail.vpn_audit_details.length"
              class="col d-flex justify-content-center p-3 m-3 mb-5"
            >
              {{ $ml.get("noVpnAccessLogFound") }}
            </h6>
            <div v-else class="row">
              <div class="col-md-9 px-4 pt-3 pt-md-0 border-right">
                <div class="col modal-body">
                  <tr
                    v-show="hackerSelectedDetail.vpn_audit_details.length"
                    v-for="(
                      item, index
                    ) in hackerSelectedDetail.vpn_audit_details"
                    :key="index"
                  >
                    <div class="mb-3">
                      <hr class="mt-1" v-if="index != 0" />
                      <p class="mb-1">
                        <b>{{ $ml.get("message") }}: </b
                        >{{ convertMessage(item.message) }}
                      </p>
                      <p class="mb-1">
                        <b>{{ $ml.get("iPAdress") }}: </b>{{ item.remote_addr }}
                      </p>
                      <p class="mb-1">
                        <b>{{ $ml.get("date") }}: </b
                        >{{
                          $utils.formatDataLong(new Date(item.timestamp * 1000))
                        }}
                      </p>
                    </div>
                  </tr>

                  <div
                    v-show="totalistDetailVpnPages > 5 && !loadingDetailVpn"
                    class="p-3 mt-4"
                  >
                    <b-pagination
                      v-model="vpnDetailAtualPage"
                      :total-rows="totalistDetailVpnPages"
                      :per-page="5"
                      :prev-text="$ml.get('previous')"
                      :next-text="$ml.get('next')"
                      align="center"
                    >
                    </b-pagination>
                  </div>
                </div>
              </div>

              <div class="col-md-12 ml-5 py-md-3 px-2 px-md-0 mt-5">
                <div id="chartModal" v-if="series[0]?.data && chartOptions">
                  <apexchart
                    type="bar"
                    height="350"
                    :options="chartOptions"
                    :series="series"
                  ></apexchart>
                </div>

                <div class="m-2 mt-4 pt-4">
                  <h6>
                    <b>{{ $ml.get("program") }}:</b>
                    {{ hackerSelectedDetail.program_name }}
                  </h6>
                  <h6>
                    <b>{{ $ml.get("vpnIP") }}:</b>
                    {{ hackerSelectedDetail.company_vpn_ip }}
                  </h6>
                  <!-- <h6><b>Horas conectadas:</b> {{series[0]?.connectedHours}}</h6> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
const moment = require("moment");
import Swal from "sweetalert2";
import ProgramService from "../../../services/program.service";

export default {
  name: "VPNs",
  props: {
    program: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      listProgram: [],
      programSelected: "",

      programSelectedGeneral: [],

      menuItem: "user",

      listState: ["Online", "Offline"],
      vpnState: "",

      programId: "",
      username: "",
      status: "",

      listVpnUsers: [],
      listVpn: [],
      hackerSelected: [],
      hackerSelectedDetail: [],

      totalistVpnPages: 0,
      totalistVpnLogsPages: 0,
      vpnAtualPage: 1,
      listVpnPageSize: 0,

      initialDate: "",
      finalDate: "",

      series: "",
      chartOptions: "",

      dateSelected: "",
      dateSelectedStart: "",
      dateSelectedEnd: "",

      loadingListVpn: false,
      loadingDetailVpn: true,
      loadingBtnExport: false,
      loadingChartUser: false,

      vpnDetailAtualPage: 1,
      totalistDetailVpnPages: 0,

      ipVPn: "",

      chartOptions2: [],
    };
  },

  mounted() {
    this.changePrograms();
    this.dateSelected = new Date();
  },

  watch: {
    initialDate: function () {
      this.dataOrder();
    },
    finalDate: function () {
      this.dataOrder();
    },

    dateSelectedStart: function () {
      this.dataOrderAccessLog();
    },
    dateSelectedEnd: function () {
      this.dataOrderAccessLog();
    },

    programSelected: function () {
      if (this.menuItem == "user") {
        this.loadData();
      }
      this.loadDataAccessLog();
    },

    programSelectedGeneral: function () {
      if (this.menuItem == "user") {
        this.loadData();
      }
      this.loadDataAccessLog();
      this.loadGraphAccessLog();
    },

    username: function () {
      this.loadData();
    },

    vpnState: function () {
      this.loadData();
    },

    vpnAtualPage: function () {
      if (this.menuItem == "user") {
        this.loadData();
      }
      this.loadDataAccessLog();
    },

    vpnDetailAtualPage: function () {
      this.modalDetail(this.hackerSelected);
    },
  },

  methods: {
    convertMessage(message) {
      if (message.match(/User disconnected/)) {
        return this.$ml.get("userDisconnected");
      }
      if (message.match(/User connected/)) {
        return this.$ml.get("userLoggedIn");
      }
      if (message.match(/User is disabled/)) {
        return this.$ml.get("connectionRefusedUserDisabled");
      }
      if (message.match(/Too many authentication attempts/)) {
        return this.$ml.get("connectionDenied");
      }
    },

    changePrograms() {
      ProgramService.getProgram("?status=in_progress&type=private").then(
        (response) => {
          this.listProgram = response.data.filter((item) => item.vpn_required);
          if (this.listProgram[0]) {
            this.programSelected = this.listProgram[0];
            this.loadData();
          }
        },
      );
    },

    dataOrder() {
      var first = this.initialDate;
      var end = this.finalDate;

      if (first && end) {
        this.vpnDetailAtualPage = 1;
        this.modalDetail(this.hackerSelected);
      } else if (!first && !end) {
        this.vpnDetailAtualPage = 1;
        this.modalDetail(this.hackerSelected);
      }
    },

    modalDetail(item) {
      var self = this;
      (this.series = []),
        (this.chartOptions = []),
        (this.loadingDetailVpn = true);
      this.hackerSelected = item;
      this.hackerSelectedDetail = [];

      this.$bvModal.show("modal-vpnDetail");
      let query = "";

      if (this.initialDate && this.finalDate) {
        let initial = this.initialDate.split("-");
        query += `&initial_date=${[initial[2], initial[1], initial[0]].join(
          "-",
        )}`;

        let end = this.finalDate.split("-");
        query += `&final_date=${[end[2], end[1], end[0]].join("-")}`;
      }

      ProgramService.getVpnAccessLog(
        item.userId || item.person_id,
        this.vpnDetailAtualPage,
        5,
        query,
      )
        .then((response) => {
          this.changeGraph(response.data.items[0].graph_data);
          this.loadingDetailVpn = false;
          this.hackerSelectedDetail = response.data.items[0];

          if (this.initialDate && this.finalDate) {
            let clearArray = [];
            this.hackerSelectedDetail.vpn_audit_details.forEach((element) => {
              let dataElement = new Date(element.timestamp * 1000);

              if (
                moment(dataElement).isBetween(
                  this.initialDate,
                  this.finalDate + " 23:59:59",
                )
              ) {
                clearArray.push(element);
              }
            });
            this.hackerSelectedDetail.vpn_audit_details = clearArray;
          }
          this.totalistDetailVpnPages = response.data.total;
        })
        .catch(() => {
          this.$bvModal.hide("modal-vpnDetail");
          this.loadingDetailVpn = false;
          Swal.fire({
            icon: "warning",
            title: self.$ml.get("unableToCompleteThisRequest"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
          });
        });
    },

    changeGraph(array) {
      let newArray = [];

      array.forEach((element) => {
        if (
          element.message.match(/User connected/) ||
          element.message.match(/User disconnected/)
        ) {
          if (this.initialDate && this.finalDate) {
            let dataElement = new Date(element.timestamp * 1000);

            if (
              moment(dataElement).isBetween(
                this.initialDate,
                this.finalDate + " 23:59:59",
              )
            ) {
              newArray.push({
                data: this.$utils.formatDataShort(
                  new Date(element.timestamp * 1000),
                ),
                dateTime: this.$utils.formatDataLong(
                  new Date(element.timestamp * 1000),
                ),
                tipo: element.message.match(/User connected/)
                  ? "Conectado"
                  : "Desconectado",
                timestamp: element.timestamp * 1000,
                contabilizado: false,
              });
            }
          } else {
            newArray.push({
              data: this.$utils.formatDataShort(
                new Date(element.timestamp * 1000),
              ),
              dateTime: this.$utils.formatDataLong(
                new Date(element.timestamp * 1000),
              ),
              tipo: element.message.match(/User connected/)
                ? "Conectado"
                : "Desconectado",
              timestamp: element.timestamp * 1000,
              contabilizado: false,
            });
          }
        }
      });

      newArray.sort(function (a, b) {
        if (a.timestamp < b.timestamp) return -1;
        if (a.timestamp > b.timestamp) return 1;
        return 0;
      });

      newArray = newArray.reduce((acc, item) => {
        if (!acc[item["data"]]) acc[item["data"]] = [];
        acc[item["data"]].push(item);
        return acc;
      }, {});

      Object.keys(newArray).forEach((item) => {
        var ms = 0;

        for (let [index, element] of newArray[item].entries()) {
          if (
            element.contabilizado == false &&
            index == 0 &&
            element.tipo == "Desconectado"
          ) {
            ms +=
              moment(element.data + " 00:00:00", "DD/MM/YYYY HH:mm:ss").diff(
                moment(element.dateTime, "DD/MM/YYYY HH:mm:ss"),
              ) * -1;
            element.contabilizado = true;
          } else if (
            element.contabilizado == false &&
            newArray[item].length == index + 1 &&
            element.tipo == "Desconectado"
          ) {
            ms +=
              moment(element.data + " 00:00:00", "DD/MM/YYYY HH:mm:ss").diff(
                moment(element.dateTime, "DD/MM/YYYY HH:mm:ss"),
              ) * -1;
            element.contabilizado = true;
          } else if (
            element.contabilizado == false &&
            newArray[item].length == index + 1 &&
            element.tipo == "Conectado"
          ) {
            ms +=
              moment(element.dateTime, "DD/MM/YYYY HH:mm:ss").diff(
                moment(element.data + " 23:59:59", "DD/MM/YYYY HH:mm:ss"),
              ) *
                -1 -
              1000;
            element.contabilizado = true;
          } else if (
            element.contabilizado == false &&
            element.tipo == "Conectado"
          ) {
            for (let [subIndex, subElement] of newArray[item].entries()) {
              if (
                element.contabilizado == false &&
                subElement.contabilizado == false &&
                subElement.tipo == "Desconectado"
              ) {
                ms += moment(subElement.dateTime, "DD/MM/YYYY HH:mm:ss").diff(
                  moment(element.dateTime, "DD/MM/YYYY HH:mm:ss"),
                );
                element.contabilizado = true;
                subElement.contabilizado = true;
                element.par = subIndex + " aqui";
                subElement.par = subIndex + " aqui";
              }
            }
          }

          var d = moment.duration(ms);
          var dateTimeFormated =
            Math.floor(d.asHours()) + moment.utc(ms).format(":mm:ss");
          element.time = dateTimeFormated;
        }
      });

      let series = [];
      let data = [];

      Object.keys(newArray).forEach((item) => {
        series.push(item);
        let time = newArray[item][newArray[item].length - 1].time;
        data.push(Number(time.split(":")[0] + "." + time.split(":")[1]));
      });

      data = data.slice().reverse().splice(0, 7);
      series = series.slice().reverse().splice(0, 7);

      (this.series = [
        {
          name: this.$ml.get("connectionTime"),
          data: data,
        },
      ]),
        (this.chartOptions = {
          colors: ["#730ca8"],
          chart: {
            type: "bar",
            stacked: true,
            stackType: "90h",
          },
          responsive: [
            {
              breakpoint: 50,
              options: {
                legend: {
                  position: "bottom",
                  offsetX: -10,
                  offsetY: 0,
                },
              },
            },
          ],
          xaxis: {
            categories: series,
          },
          fill: {
            opacity: 1,
          },
          legend: {
            position: "right",
            offsetX: 0,
            offsetY: 50,
          },
          dataLabels: {
            enabled: true,
            formatter: function (val) {
              var minutos = String(val).split(".")[1]
                ? String(val).split(".")[1]
                : 0;
              return String(val).split(".")[0] + "h " + minutos + "m";
            },
          },

          title: {
            text: this.$ml.get("totalEvents"),
            align: "left",
          },
          subtitle: {
            text: this.$ml.get("last7daysOfAccess"),
            align: "left",
          },

          yaxis: {
            labels: {
              show: false,
              formatter: function (val) {
                var minutos = String(val).split(".")[1]
                  ? String(val).split(".")[1]
                  : 0;
                return String(val).split(".")[0] + "h " + minutos + "m";
              },
            },
          },
        });
    },

    exporCSVDetail(hackerSelected) {
      var self = this;
      this.loadingBtnExport = true;

      ProgramService.getVpnAccessLog(
        hackerSelected.userId || hackerSelected.person_id,
      )
        .then((response) => {
          var item = response.data.items[0].vpn_audit_details
            .slice(0)
            .reverse();

          var headers = {
            _id: "Id",
            user_name: "Usuário",
            type: "Tipo",
            message: "Mensagem",
            timestamp: "Data",
            remote_addr: "IP",
          };
          var itemsFormatted = [];
          // format the data
          item.forEach((item) => {
            if (item.message.match(/User disconnected/)) {
              item.message = "Usuário desconectado!";
            }
            if (item.message.match(/User connected/)) {
              item.message = "Usuário conectado!";
            }
            if (item.message.match(/User is disabled/)) {
              item.message = "Conexão recusada, usuário desativado!";
            }

            itemsFormatted.push({
              _id: item._id,
              user_name: item.user_name,
              type: item.type,
              message: item.message,
              timestamp: this.$utils.formatDataLong(
                new Date(item.timestamp * 1000),
              ),
              remote_addr: item.remote_addr,
            });
          });

          itemsFormatted.unshift(headers);

          // Convert Object to JSON
          var jsonObject = JSON.stringify(itemsFormatted);

          var array =
            typeof jsonObject != "object" ? JSON.parse(jsonObject) : jsonObject;
          var csv = "";

          for (var i = 0; i < array.length; i++) {
            var line = "";
            for (var index in array[i]) {
              if (line != "") line += ";";
              line += array[i][index];
            }
            csv += line + "\r\n";
          }

          const anchor = document.createElement("a");
          anchor.href =
            "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
          anchor.target = "_blank";
          anchor.download = `${item[0].user_name}_log_vpn.csv`;
          anchor.click();

          this.loadingBtnExport = false;
        })
        .catch(() => {
          this.loadingBtnExport = false;
          Swal.fire({
            icon: "warning",
            title: self.$ml.get("unableToCompleteThisRequest"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
          });
        });
    },

    loadData() {
      var self = this;
      this.loadingListVpn = true;

      this.listVpnUsers = [];

      let query = "";

      if (this.username) {
        query += `&username=${this.username}`;
      }

      if (this.vpnState) {
        query += `&status=${this.vpnState.toLowerCase()}`;
      }

      if (!this.programSelected._id) {
        return;
      }

      ProgramService.getVpnGeneral(
        this.vpnAtualPage,
        10,
        this.programSelected._id,
        query,
      )
        .then(({ data }) => {
          self.ipVPn = data.items[0];

          self.listVpnUsers = data.items;
          self.totalistVpnPages = data.total;
          self.listVpnPageSize = data.pageSize;
          self.loadingListVpn = false;
        })
        .catch(() => {
          self.loadingListVpn = false;
          Swal.fire({
            icon: "warning",
            title: self.$ml.get("unableToCompleteThisRequest"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
          });
        });
    },

    dataOrderAccessLog() {
      var first = this.dateSelectedStart;
      var end = this.dateSelectedEnd;

      if (first && end) {
        this.loadDataAccessLog();
        this.loadGraphAccessLog();
      } else if (!first && !end) {
        this.loadDataAccessLog();
        this.loadGraphAccessLog();
      }
    },

    loadDataAccessLog() {
      var self = this;
      this.loadingListVpn = true;

      this.listVpn = [];

      let query = "";

      if (this.dateSelectedStart && this.dateSelectedEnd) {
        let initial = this.dateSelectedStart.split("-");
        query += `&initial_date=${[initial[2], initial[1], initial[0]].join(
          "-",
        )}`;

        let end = this.dateSelectedEnd.split("-");
        query += `&final_date=${[end[2], end[1], end[0]].join("-")}`;
      }

      ProgramService.getVpnGeneralLog(
        this.vpnAtualPage,
        10,
        this.programSelectedGeneral?._id,
        query,
      )
        .then(({ data }) => {
          self.listVpn = data.items;
          self.totalistVpnLogsPages = data.total;
          self.listVpnPageSize = data.pageSize;
          self.loadingListVpn = false;
        })
        .catch(() => {
          self.loadingListVpn = false;
          Swal.fire({
            icon: "warning",
            title: self.$ml.get("unableToCompleteThisRequest"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
          });
        });
    },

    loadGraphAccessLog() {
      var self = this;

      let query = "";

      if (this.dateSelectedStart && this.dateSelectedEnd) {
        let initial = this.dateSelectedStart.split("-");
        query += `&initial_date=${[initial[2], initial[1], initial[0]].join(
          "-",
        )}`;

        let end = this.dateSelectedEnd.split("-");
        query += `&final_date=${[end[2], end[1], end[0]].join("-")}`;
      }

      this.chartOptions2 = [];

      this.loadingChartUser = true;

      ProgramService.getVpnGeneralLog(
        this.vpnAtualPage,
        999,
        this.programSelectedGeneral?._id,
        query,
      )
        .then(({ data }) => {
          self.changeGraphAccess(data.items);
        })
        .catch(() => {
          self.loadingChartUser = false;
          Swal.fire({
            icon: "warning",
            title: self.$ml.get("unableToCompleteThisRequest"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
          });
        });
    },
    changeGraphAccess(array) {
      let newArray = [];

      array.forEach((element) => {
        if (
          element.message.match(/User connected/) ||
          element.message.match(/User disconnected/)
        ) {
          newArray.push({
            name: element.username,
            data: this.$utils.formatDataShort(
              new Date(element.timestamp * 1000),
            ),
            dateTime: this.$utils.formatDataLong(
              new Date(element.timestamp * 1000),
            ),
            tipo: element.message.match(/User connected/)
              ? "Conectado"
              : "Desconectado",
            timestamp: element.timestamp * 1000,
            contabilizado: false,
          });
        }
      });

      newArray.sort(function (a, b) {
        if (a.timestamp < b.timestamp) return -1;
        if (a.timestamp > b.timestamp) return 1;
        return 0;
      });

      newArray = newArray.reduce((acc, item) => {
        if (!acc[item["name"]]) acc[item["name"]] = [];
        acc[item["name"]].push(item);
        return acc;
      }, {});

      Object.keys(newArray).forEach((users) => {
        var ms = 0;

        for (let [index, element] of newArray[users].entries()) {
          if (
            element.contabilizado == false &&
            index == 0 &&
            element.tipo == "Desconectado"
          ) {
            ms +=
              moment(element.data + " 00:00:00", "DD/MM/YYYY HH:mm:ss").diff(
                moment(element.dateTime, "DD/MM/YYYY HH:mm:ss"),
              ) * -1;
            element.contabilizado = true;
          } else if (
            element.contabilizado == false &&
            newArray[users].length == index + 1 &&
            element.tipo == "Conectado"
          ) {
            ms +=
              moment(element.dateTime, "DD/MM/YYYY HH:mm:ss").diff(
                moment(element.data + " 23:59:59", "DD/MM/YYYY HH:mm:ss"),
              ) *
                -1 +
              1000;
            element.contabilizado = true;
          } else if (
            element.contabilizado == false &&
            element.tipo == "Conectado"
          ) {
            for (let [subIndex, subElement] of newArray[users].entries()) {
              if (
                element.contabilizado == false &&
                subElement.contabilizado == false &&
                subElement.tipo == "Desconectado"
              ) {
                ms += moment(subElement.dateTime, "DD/MM/YYYY HH:mm:ss").diff(
                  moment(element.dateTime, "DD/MM/YYYY HH:mm:ss"),
                );
                element.contabilizado = true;
                subElement.contabilizado = true;
                element.par = subIndex;
                subElement.par = subIndex;
              }
            }
          }

          var d = moment.duration(ms);
          var dateTimeFormated =
            Math.floor(d.asHours()) + moment.utc(ms).format(":mm:ss");
          element.time = dateTimeFormated;
        }
      });

      let series = [];
      let data = [];

      Object.keys(newArray).forEach((item) => {
        series.push(item);
        let time = newArray[item][newArray[item].length - 1].time;
        data.push(Number(time.split(":")[0] + "." + time.split(":")[1]));
      });

      this.loadingChartUser = false;

      this.chartOptions2 = {
        heightChart: data.length,

        visible: true,
        colors: ["#730ca8"],
        series: [
          {
            name: this.$ml.get("connectionTime"),
            data: data,
          },
        ],

        chart: {
          type: "bar",
        },
        plotOptions: {
          bar: {
            borderRadius: 4,
            horizontal: true,
          },
        },
        dataLabels: {
          enabled: false,
        },
        xaxis: {
          categories: series,
          labels: {
            show: false,
          },
        },

        yaxis: {
          labels: {
            show: true,
            formatter: function (val) {
              return String(val).split(".")[1]
                ? String(val).split(".")[0] +
                    "h " +
                    String(val).split(".")[1] +
                    "m"
                : val;
            },
          },
        },

        title: {
          text: this.$ml.get("connectionsPerUser"),
          align: "left",
          style: {
            color: "rgb(32, 33, 37)",
            fontWeight: "400",
            lineHeight: "1.2",
          },
        },
      };
    },

    toogleVpnStatus(personId, action) {
      var self = this;

      ProgramService.putVpnHacker(this.programSelected._id, personId, action)
        .then(() => {
          this.loadData();
          Swal.fire({
            icon: "success",
            title: self.$ml.get("dataChanged"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
          });
        })
        .catch(() => {
          Swal.fire({
            icon: "warning",
            title: self.$ml.get("unableToCompleteThisRequest"),
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
          });
        });
    },
  },
};
</script>

<style scoped>
li {
  padding-bottom: 1rem;
}
.primary-text {
  color: #730ba9 !important;
}
.nda-icon-button {
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center !important;
  align-content: center !important;
  align-items: center !important;
  border-radius: 5px;
}
.ico-btn {
  width: auto;
  height: auto;
  display: flex;
  justify-content: center;
  align-content: center;
  align-items: center;
  border-radius: 5px;
}
.img-ico-btn {
  width: 30px;
  height: 20px;
  align-self: center;
}
.title-conexao-usuario {
  color: #44527a;
  font-weight: 200;
  font-size: 15px;
}
</style>
<!-- User disconnected from "bbp-nuclea" 189.6.15.176 10:11 am - Jan 23 2023
 User connected to "bbp-nuclea" 189.6.15.176 10:07 am - Jan 23 2023   

 User disconnected from "bbp-nuclea" 179.214.126.241 6:11 pm - Dec 30 2022   
 User connected to "bbp-nuclea" 179.214.126.241 4:29 pm - Dec 30 2022 
 User disconnected from "bbp-nuclea" 179.214.126.241 4:29 pm - Dec 30 2022  
 User connected to "bbp-nuclea" 179.214.126.241 4:29 pm - Dec 30 2022
 User disconnected from "bbp-nuclea" 179.214.126.241 4:29 pm - Dec 30 2022  
 User connected to "bbp-nuclea" 179.214.126.241 4:29 pm - Dec 30 2022 
 User disconnected from "bbp-nuclea" 179.214.126.241 4:29 pm - Dec 30 2022
 User connected to "bbp-nuclea" 179.214.126.241 4:29 pm - Dec 30 2022
 User disconnected from "bbp-nuclea" 179.214.126.241 4:28 pm - Dec 30 2022
 User connected to "bbp-nuclea" 179.214.126.241 4:28 pm - Dec 30 2022
 User disconnected from "bbp-nuclea" 179.214.126.241 4:28 pm - Dec 30 2022
 User connected to "bbp-nuclea" 179.214.126.241 4:28 pm - Dec 30 2022
 User disconnected from "bbp-nuclea" 179.214.126.241 4:28 pm - Dec 30 2022
 User connected to "bbp-nuclea" 179.214.126.241 4:28 pm - Dec 30 2022
 User disconnected from "bbp-nuclea" 179.214.126.241 4:28 pm - Dec 30 2022
 User connected to "bbp-nuclea" 179.214.126.241 4:27 pm - Dec 30 2022
 User disconnected from "bbp-nuclea" 179.214.126.241 4:27 pm - Dec 30 2022
 User connected to "bbp-nuclea" 179.214.126.241 4:27 pm - Dec 30 2022
 User disconnected from "bbp-nuclea" 179.214.126.241 4:27 pm - Dec 30 2022
 User connected to "bbp-nuclea" 179.214.126.241 4:27 pm - Dec 30 2022
 User disconnected from "bbp-nuclea" 179.214.126.241 4:27 pm - Dec 30 2022
 User connected to "bbp-nuclea" 179.214.126.241 4:27 pm - Dec 30 2022
 User disconnected from "bbp-nuclea" 179.214.126.241 4:26 pm - Dec 30 2022
 User connected to "bbp-nuclea" 179.214.126.241 4:26 pm - Dec 30 2022
 User disconnected from "bbp-nuclea" 179.214.126.241 4:26 pm - Dec 30 2022
 User connected to "bbp-nuclea" 179.214.126.241 4:26 pm - Dec 30 2022
 User disconnected from "bbp-nuclea" 179.214.126.241 4:26 pm - Dec 30 2022  
 User connected to "bbp-nuclea" 179.214.126.241 4:26 pm - Dec 30 2022
 User disconnected from "bbp-nuclea" 179.214.126.241 4:26 pm - Dec 30 2022  
 User connected to "bbp-nuclea" 179.214.126.241 4:26 pm - Dec 30 2022
 
 
 User disconnected from "bbp-nuclea" 161.97.85.138 4:29 pm - Dec 30 2022
 User connected to "bbp-nuclea" 161.97.85.138 4:29 pm - Dec 30 2022 
 User disconnected from "bbp-nuclea" 161.97.85.138 4:29 pm - Dec 30 2022
 User connected to "bbp-nuclea" 161.97.85.138 4:29 pm - Dec 30 2022 
 User disconnected from "bbp-nuclea" 161.97.85.138 4:29 pm - Dec 30 2022
 User connected to "bbp-nuclea" 161.97.85.138 4:29 pm - Dec 30 2022
 User disconnected from "bbp-nuclea" 161.97.85.138 4:29 pm - Dec 30 2022
 User connected to "bbp-nuclea" 161.97.85.138 4:28 pm - Dec 30 2022
 User disconnected from "bbp-nuclea" 161.97.85.138 4:28 pm - Dec 30 2022
 User connected to "bbp-nuclea" 161.97.85.138 4:28 pm - Dec 30 2022
 User disconnected from "bbp-nuclea" 161.97.85.138 4:28 pm - Dec 30 2022
 User connected to "bbp-nuclea" 161.97.85.138 4:28 pm - Dec 30 2022
 User disconnected from "bbp-nuclea" 161.97.85.138 4:28 pm - Dec 30 2022
 User connected to "bbp-nuclea" 161.97.85.138 4:27 pm - Dec 30 2022
 User disconnected from "bbp-nuclea" 161.97.85.138 4:27 pm - Dec 30 2022
 User connected to "bbp-nuclea" 161.97.85.138 4:27 pm - Dec 30 2022
 User disconnected from "bbp-nuclea" 161.97.85.138 4:27 pm - Dec 30 2022
 User connected to "bbp-nuclea" 161.97.85.138 4:27 pm - Dec 30 2022

User disconnected from "bbp-nuclea" 161.97.85.138 4:27 pm - Dec 30 2022
User connected to "bbp-nuclea" 161.97.85.138 4:27 pm - Dec 30 2022
User disconnected from "bbp-nuclea" 161.97.85.138 4:27 pm - Dec 30 2022
User connected to "bbp-nuclea" 161.97.85.138 4:26 pm - Dec 30 2022
User disconnected from "bbp-nuclea" 161.97.85.138 4:26 pm - Dec 30 2022
User connected to "bbp-nuclea" 161.97.85.138 4:26 pm - Dec 30 2022
User disconnected from "bbp-nuclea" 161.97.85.138 4:26 pm - Dec 30 2022
User connected to "bbp-nuclea" 161.97.85.138 4:26 pm - Dec 30 2022
User disconnected from "bbp-nuclea" 161.97.85.138 4:26 pm - Dec 30 2022
User connected to "bbp-nuclea" 161.97.85.138 4:26 pm - Dec 30 2022
User disconnected from "bbp-nuclea" 161.97.85.138 4:26 pm - Dec 30 2022
User connected to "bbp-nuclea" 161.97.85.138 4:25 pm - Dec 30 2022 -->
